import CadastrarCaixaTypes from './types'

export const clear = () => ({
    type: CadastrarCaixaTypes.CLEAR,
})

export const sequencialOriginalRequest = ({nomeAplicacao}) => ({
    type: CadastrarCaixaTypes.SEQUENCIAL_ORIGINAL_REQUEST,
    payload: {nomeAplicacao}
})

export const sequencialCopiaRequest = ({nomeAplicacao}) => ({
    type: CadastrarCaixaTypes.SEQUENCIAL_COPIA_REQUEST,
    payload: {nomeAplicacao}
})

export const sequencialSuccess = (payload) => ({
    type: CadastrarCaixaTypes.SEQUENCIAL_SUCCESS,
    payload: payload
})

export const searchCaixaRequest = ( caixaReimpressao ) => ({
    type: CadastrarCaixaTypes.SEARCH_CAIXA_REQUEST,
    payload: caixaReimpressao
})

export const searchCaixaSuccess = (payload) => ({
    type: CadastrarCaixaTypes.SEARCH_CAIXA_SUCCESS,
    payload: payload
})

export const insertRequest = (payload) => ({
    type: CadastrarCaixaTypes.INSERT_REQUEST,
    payload
})

export const insertSuccess = (payload) => ({
    type: CadastrarCaixaTypes.INSERT_SUCCESS,
    payload: payload
})

export const requestFailure = () => ({
    type: CadastrarCaixaTypes.REQUEST_FAILURE,
})

export const setTipo = (value) => ({
    type: CadastrarCaixaTypes.TIPO,
    payload: { tipo:value }
})

export const setCapas = (dados) => ({
    type: CadastrarCaixaTypes.CAPA_SEARCH,
    payload: dados
})

export const sendToPrint = () => ({
    type: CadastrarCaixaTypes.CAPA_PRINT,
})

export const getPrinted = (dados) => ({
    type: CadastrarCaixaTypes.CAPA_PRINT,
    payload: dados
})